export default "__VITE_ASSET__B_YX8JOc__"